import React from "react";

interface UpdateDescriptionIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

export default function UpdateDescriptionIcon({
  size = 18,
  color = "#25CC38",
  className,
}: UpdateDescriptionIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9.33333 11.0572L9 12.3905L10.3333 12.0572L14.1953 8.19519C14.3203 8.07017 14.3905 7.90063 14.3905 7.72386C14.3905 7.54708 14.3203 7.37754 14.1953 7.25252L14.138 7.19519C14.013 7.07021 13.8434 7 13.6667 7C13.4899 7 13.3204 7.07021 13.1953 7.19519L9.33333 11.0572ZM12.6667 7.72386L13.6667 8.72386ZM12 12.3905H14.6667Z"
        fill="white"
      />
      <path
        d="M12.6667 7.72386L13.6667 8.72386M12 12.3905H14.6667M9.33333 11.0572L9 12.3905L10.3333 12.0572L14.1953 8.19519C14.3203 8.07017 14.3905 7.90063 14.3905 7.72386C14.3905 7.54708 14.3203 7.37754 14.1953 7.25252L14.138 7.19519C14.013 7.07021 13.8434 7 13.6667 7C13.4899 7 13.3204 7.07021 13.1953 7.19519L9.33333 11.0572Z"
        stroke={color}
        stroke-width="0.7"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 0.6C0 0.44087 0.0592632 0.288258 0.164752 0.175736C0.270242 0.063214 0.413316 0 0.5625 0H11.4375C11.5867 0 11.7298 0.063214 11.8352 0.175736C11.9407 0.288258 12 0.44087 12 0.6C12 0.75913 11.9407 0.911742 11.8352 1.02426C11.7298 1.13679 11.5867 1.2 11.4375 1.2H0.5625C0.413316 1.2 0.270242 1.13679 0.164752 1.02426C0.0592632 0.911742 0 0.75913 0 0.6ZM0 4C0 3.84087 0.0592632 3.68826 0.164752 3.57574C0.270242 3.46321 0.413316 3.4 0.5625 3.4H11.4375C11.5867 3.4 11.7298 3.46321 11.8352 3.57574C11.9407 3.68826 12 3.84087 12 4C12 4.15913 11.9407 4.31174 11.8352 4.42426C11.7298 4.53679 11.5867 4.6 11.4375 4.6H0.5625C0.413316 4.6 0.270242 4.53679 0.164752 4.42426C0.0592632 4.31174 0 4.15913 0 4ZM0.5625 6.8C0.413316 6.8 0.270242 6.86321 0.164752 6.97574C0.0592632 7.08826 0 7.24087 0 7.4C0 7.55913 0.0592632 7.71174 0.164752 7.82426C0.270242 7.93679 0.413316 8 0.5625 8H7.6875C7.83668 8 7.97976 7.93679 8.08525 7.82426C8.19074 7.71174 8.25 7.55913 8.25 7.4C8.25 7.24087 8.19074 7.08826 8.08525 6.97574C7.97976 6.86321 7.83668 6.8 7.6875 6.8H0.5625Z"
        fill={color}
      />
    </svg>
  );
}
